
/* Sepet satırını favorilere ekler. Sepet çekmecesi ve sepet sayfası aynı
   diyaloğu iki ayrı Alpine bileşeninde kurduğu için ortak yer burası.

   Runtime'ın belgeli genel API'si kullanılır (window.Entrfy.runtime.wishlist);
   eklenti kurulu değilse ya da henüz yüklenmediyse sessizce geçer — "sil"
   eylemi favori eklenemedi diye durmamalı. */
window.gaWishlistAdd = async function gaWishlistAdd(item) {
  try {
    const wl = window.Entrfy?.runtime?.wishlist;
    if (!wl || !item?.variant_id) return false;
    await wl.addItem({
      productId: String(item.product_id),
      variantId: String(item.variant_id),
      placement: 'cart',
      snapshot: {
        title: item.product_title || null,
        imageUrl: item.image || null,
        variantTitle: item.variant_title || null,
        priceAtAdd: typeof item.price === 'number' ? item.price / 100 : null,
        currency: window.Shopify?.currency?.active || null
      },
      context: { url: item.url || location.pathname }
    });
    return true;
  } catch (e) {
    window.gaErr?.('[GA] wishlist add from cart failed', e);
    return false;
  }
};
/* Sepet satırının adedini değiştirir ve Shopify'ın istenen adedi uygulayıp
   uygulamadığına bakar. Stok (ya da adet kuralı) yetmediğinde Shopify ya 422
   döner ya da adedi sessizce kısar; ikisinde de satır olduğu gibi kalır ve "+"ya
   basan kullanıcı hiçbir şey olmadığını görür. Dönen `warn`, satırın altında
   gösterilecek uyarı metnidir (sorun yoksa null). Metinler temanın dil
   dosyasından gelir (window.cartStrings), yani bütün dillerde hazır.
   Sepet çekmecesi, sepet sayfası ve sepet sayfası 02 ortak kullanır.
   target: { id: <satır key'i> } ya da { line: <1'den başlayan sıra> } */
window.gaCartChange = async function gaCartChange(target, qty, current) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(Object.assign({}, target, { quantity: qty }))
  });
  let data = null;
  try { data = await res.json(); } catch (e) {}

  let max = null;
  let warn = null;
  if (res.ok && data && Array.isArray(data.items)) {
    const row = target.id != null
      ? data.items.find((i) => i.key === target.id)
      : data.items[target.line - 1];
    const got = row ? row.quantity : 0;
    if (qty > got && got > 0) max = got;
  } else if (!res.ok) {
    /* 422'de sepet değişmez. "+1" reddedildiyse sınır mevcut adettir; elle
       yazılan bir adet reddedildiyse sınırı bilemeyiz → genel hata metni. */
    if (current > 0 && qty === current + 1) max = current;
    else warn = window.cartStrings?.error || null;
  }
  if (max != null) {
    const tpl = window.cartStrings?.quantityError;
    warn = tpl ? tpl.replace('[quantity]', max) : null;
  }
  return { ok: res.ok, data, warn };
};

window.debounce = function (fn, wait) {
  let t;
  return function (...a) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, a), wait);
  };
};

/* --- Sepet promosyonlari -----------------------------------------------
   Yapilandirma ve sepetteki urunlerin koleksiyon haritasi, `ga-cart-promo-data`
   snippet'i tarafindan sayfaya JSON olarak basilir. Promo kapaliysa o script'ler
   hic basilmaz ve buradaki her sey sessizce devre disi kalir. */
window.gaPromoConfig = function () {
  const el = document.querySelector('[data-ga-promo-config]');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
};

window.gaPromoCollections = function () {
  const el = document.querySelector('[data-ga-promo-collections]');
  if (!el) return {};
  try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
};

window.gaInCollection = function (map, productId, handle) {
  if (!handle) return false;
  const list = map[String(productId)] || map[productId];
  return Array.isArray(list) && list.indexOf(handle) !== -1;
};

/* 'ITEM' / 'COUNT' / 'PRICE' yer tutucularini doldurur. */
window.gaPromoText = function (key, vars) {
  const raw = (window.GA_PROMO_STRINGS || {})[key];
  if (!raw) return '';
  return Object.keys(vars || {}).reduce(
    (out, k) => out.split(k).join(vars[k]),
    raw
  );
};

function withAlpine(cb) {
  if (window.Alpine) cb(window.Alpine);
  else document.addEventListener('alpine:init', () => cb(window.Alpine));
}

withAlpine((Alpine) => {
Alpine.data('gaCartDrawer', (threshold) => ({
  threshold,
  open: false,
  updating: false,
  updatingKey: null,

  cart: { items: [], total_price: 0, item_count: 0 },
  t: window.GA_CART_TRANSLATIONS || {},

    thresholdCents: 0,
    giftThresholdCents: 0,
    nextDayThresholdCents: 0,
    progressMaxCents: 0,
    giftAnimProgress: 0,

    close() {
      this.open = false;
    },

    promo: null,
    promoMap: {},
    _promoNormalizing: false,

    isFreeGift(item) {
      /* Esik tabanli hediye ile promo hediyesi ayni isareti tasir; ikisi de
         ara toplamdan dislanir ki hediye kendi esigini beslemesin. */
      return item?.properties?._free_gift === 'true';
    },

    /* --- Promo 1: tetikleyici koleksiyon -> hediye --- */
    get promoGiftOn() {
      return !!(this.promo && this.promo.gift && this.promo.gift.on);
    },

    get promoHasTrigger() {
      if (!this.promoGiftOn) return false;
      const h = this.promo.gift.trigger;
      return (this.cart.items || []).some((i) =>
        window.gaInCollection(this.promoMap, i.product_id, h)
      );
    },

    get promoHasGift() {
      if (!this.promoGiftOn) return false;
      const h = this.promo.gift.collection;
      return (this.cart.items || []).some(
        (i) => this.isFreeGift(i) && window.gaInCollection(this.promoMap, i.product_id, h)
      );
    },

    /* Tetikleyici sepetten cikarsa hediyeyi sil; birden fazla hediye kaldiysa
       teke indir. Sepet her tazelendiginde calisir. */
    async normalizePromoGift() {
      if (!this.promoGiftOn || this._promoNormalizing) return;
      const h = this.promo.gift.collection;
      const gifts = (this.cart.items || []).filter(
        (i) => this.isFreeGift(i) && window.gaInCollection(this.promoMap, i.product_id, h)
      );
      if (!gifts.length) return;

      let drop = [];
      if (!this.promoHasTrigger) drop = gifts;
      else if (gifts.length > 1) drop = gifts.slice(1);
      if (!drop.length) return;

      this._promoNormalizing = true;
      try {
        for (const g of drop) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: g.key, quantity: 0 })
          });
        }
        await this.fetchCart(false);
      } catch (e) {
        window.gaErr('[GA] promo gift normalize error', e);
      } finally {
        this._promoNormalizing = false;
      }
    },

    /* Hediye seciciden secilen varyanti sepete ekler. `_free_gift` isareti
       urunu ara toplamdan dislar ve tetikleyici cikarsa silinmesini saglar. */
    async addPromoGift(variantId, sid) {
      if (!variantId || this.updating) return;
      this.updating = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _free_gift: 'true' } }]
          })
        });
        await this.fetchCart();
        if (sid) {
          document.getElementById('ga-cart-scroll-' + sid)?.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } catch (e) {
        window.gaErr('[GA] promo gift add error', e);
      } finally {
        this.updating = false;
      }
    },

    /* --- Promo 2: koleksiyondan N adet -> paket fiyati --- */
    get promoBundleOn() {
      return !!(this.promo && this.promo.bundle && this.promo.bundle.on);
    },

    get promoBundleCount() {
      if (!this.promoBundleOn) return 0;
      const h = this.promo.bundle.collection;
      return (this.cart.items || []).reduce(
        (n, i) => (window.gaInCollection(this.promoMap, i.product_id, h) ? n + i.quantity : n),
        0
      );
    },

    get promoBundleQty() {
      return this.promoBundleOn ? Number(this.promo.bundle.qty || 2) : 0;
    },

    get promoBundleComplete() {
      return this.promoBundleOn && this.promoBundleCount >= this.promoBundleQty;
    },

    get promoBundleProgress() {
      if (!this.promoBundleQty) return 0;
      return Math.min((this.promoBundleCount / this.promoBundleQty) * 100, 100);
    },

    get promoBundleMessage() {
      if (!this.promoBundleOn) return '';
      const b = this.promo.bundle;
      const remaining = this.promoBundleQty - this.promoBundleCount;
      if (this.promoBundleCount === 0) {
        return window.gaPromoText('bundle_offer', {
          COUNT: this.promoBundleQty, ITEM: b.name || '', PRICE: b.price || ''
        });
      }
      if (remaining > 0) {
        return window.gaPromoText('bundle_add_more', { COUNT: remaining, ITEM: b.name || '' });
      }
      return window.gaPromoText('bundle_done', {});
    },

    get promoGiftMessage() {
      if (!this.promoGiftOn) return '';
      const g = this.promo.gift;
      if (!this.promoHasTrigger) return window.gaPromoText('gift_add_trigger', { ITEM: g.name || '' });
      if (this.promoHasGift) return window.gaPromoText('gift_added', { ITEM: g.name || '' });
      return window.gaPromoText('gift_choose', { ITEM: g.name || '' });
    },

    get qualifyingSubtotalCents() {
      return (this.cart.items || []).reduce((sum, item) => {
        if (this.isFreeGift(item)) return sum;
        return sum + (item.final_line_price || 0);
      }, 0);
    },

    get giftQualified() {
      return !!this.giftThresholdCents && this.qualifyingSubtotalCents >= this.giftThresholdCents;
    },

    get hasFreeGift() {
      return (this.cart.items || []).some((item) => this.isFreeGift(item));
    },

    get remainingToFreeShipCents() {
      return Math.max(this.thresholdCents - this.qualifyingSubtotalCents, 0);
    },

    get remainingToGiftCents() {
      return Math.max(this.giftThresholdCents - this.qualifyingSubtotalCents, 0);
    },
    get remainingToNextDayCents() {
      return Math.max(this.nextDayThresholdCents - this.qualifyingSubtotalCents, 0);
    },

    get nextDayQualified() {
      return !!this.nextDayThresholdCents && this.qualifyingSubtotalCents >= this.nextDayThresholdCents;
    },

    get progressPercent() {
      if (!this.progressMaxCents) return 0;

      return Math.min(
        (this.qualifyingSubtotalCents / this.progressMaxCents) * 100,
        100
      );
    },

    get shippingPosition() {
      if (!this.progressMaxCents) return 0;

      return Math.min(
        (this.thresholdCents / this.progressMaxCents) * 100,
        100
      );
    },

    get giftPosition() {
      if (!this.progressMaxCents) return 0;

      return Math.min(
        (this.giftThresholdCents / this.progressMaxCents) * 100,
        100
      );
    },
    get nextDayPosition() {
        if (!this.progressMaxCents) return 0;

        return Math.min(
          (this.nextDayThresholdCents / this.progressMaxCents) * 100,
          100
        );
      },

    get subtotal() {
      return this.cart.total_price / 100;
    },

    formatMoney(cents) {
      if (window.formatMoneyCents) return window.formatMoneyCents(cents);
      return (cents / 100).toFixed(2);
    },

    init() {
        this.thresholdCents = Math.round((Number(this.threshold) || 0) * 100);
        this.giftThresholdCents = Math.round(
          (Number(window.GIFT_ENGINE_CONFIG?.threshold) || 0) * 100
        );
        this.nextDayThresholdCents = Math.round(
          (Number(window.GA_NEXT_DAY_THRESHOLD) || 0) * 100
        );

      this.progressMaxCents = Math.max(
        this.thresholdCents,
        this.giftThresholdCents,
        this.nextDayThresholdCents
      );

      /* Initial sync just needs the count/items — skip the discount-touch write. */
      this.fetchCart(false);

      /* Opening the drawer is handled declaratively by `x-on:toggle-cart.window`
         in the section markup, which also refreshes the cart — no duplicate here. */
      window.addEventListener('cart:refresh', () => {
        this.fetchCart();
      });
    },

    async fetchCart(touch = true) {
      try {
        /* Touch a cart attribute so Shopify re-evaluates automatic discounts
           (Buy X Get Y, free-gift, etc.) before we read the cart. The
           `platform` attribution attribute is set here too, in the same write.
           Skipped on the initial page-load sync (touch=false) — only needed when
           the drawer is actually shown — to save a POST on every page. */
        if (touch) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _dt: Date.now().toString(), platform: 'web' } })
          }).catch(() => {});
        }

        const data = await fetch('/cart.js').then(r => r.json());

        this.cart.items = (data.items || []).map((item) => ({
          product_id: item.product_id,
          key: item.key,
          id: item.variant_id,
          variant_id: item.variant_id,
          quantity: item.quantity,
          variant_title: item.variant_title,
          product_title: item.product_title,
          final_line_price: item.final_line_price,
          original_line_price: item.original_line_price,
          final_unit_price: item.final_price ?? item.price,
          original_unit_price: item.original_price,
          image: item.image,
          url: item.url,
          price: item.price,
          original_price: item.original_price,
          discounts: (item.line_level_discount_allocations || []).map(d => d.discount_application?.title).filter(Boolean),
          properties: item.properties || {}
        }));

        this.cart.total_price = data.total_price || 0;
        this.cart.item_count = data.item_count || 0;

        window.GA_CART = data;

        window.dispatchEvent(
          new CustomEvent('cart:updated', { detail: data })
        );

        this.$nextTick(() => {
          const target = this.progressPercent;
          let start = this.giftAnimProgress;

          const step = () => {
            start += (target - start) * 0.15;
            this.giftAnimProgress = start;

            if (Math.abs(target - start) > 0.3) {
              requestAnimationFrame(step);
            } else {
              this.giftAnimProgress = target;
            }
          };

          step();
        });
        /* Promo yapilandirmasi ve koleksiyon haritasi sepetle birlikte tazelenir;
           section yeniden render edildiginde JSON script'leri de yenilenmis olur. */
        this.promo = window.gaPromoConfig();
        this.promoMap = window.gaPromoCollections();
        if (this.promoGiftOn) this.normalizePromoGift();
      } catch (e) {
        window.gaErr('[GA] fetchCart error', e);
      }
    },

    /* Stok/adet sınırı uyarısı: { key, msg }. Bir sonraki adet değişikliğinde silinir. */
    qtyWarn: null,

    async _changeCart(key, qty) {
      this.updating = true;
      this.updatingKey = key;
      this.qtyWarn = null;
      const cur = (this.cart.items || []).find((i) => i.key === key);

      try {
        const r = await window.gaCartChange({ id: key }, qty, cur ? cur.quantity : 0);

        await this.fetchCart();
        if (r.warn) this.qtyWarn = { key, msg: r.warn };
      } catch (e) {
        window.gaErr('[GA] cart change error', e);
      } finally {
        this.updating = false;
        this.updatingKey = null;
      }
    },

    async incrementItem(item) {
      if (this.updating) return;

      if (this.isFreeGift(item)) {
        this.updating = true;
        this.updatingKey = item.key;

        try {
          if (window.GiftEngine?.addPaidCopyOfGiftVariant) {
            await window.GiftEngine.addPaidCopyOfGiftVariant(item.variant_id);
          } else {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.variant_id,
                quantity: 1
              }),
            });
          }

          await this.fetchCart();
        } catch (e) {
          window.gaErr('[GA] increment free gift error', e);
        } finally {
          this.updating = false;
          this.updatingKey = null;
        }

        return;
      }

      this._changeCart(item.key, item.quantity + 1);
    },

    decrementItem(item) {
      if (item.quantity <= 1) {
        this.removeItem(item.key);
        return;
      }

      this._changeCart(item.key, item.quantity - 1);
    },

    updateQuantity(key, q) {
      q < 1 ? this.removeItem(key) : this._changeCart(key, q);
    },

    removeItem(key) {
      this._changeCart(key, 0);
    },

    // ----- Remove-with-confirmation -----
    // Cart drawer / cart page click the trash icon → requestRemove(item)
    // → modal opens. User picks one of three actions (or dismisses).
    pendingRemove: null,
    pendingRemoveBusy: false,

    requestRemove(item) {
      if (!item) return;
      this.pendingRemove = item;
      this.pendingRemoveBusy = false;
      // lock body scroll while modal is open
      document.documentElement.style.overflow = 'hidden';
    },

    cancelRemove() {
      this.pendingRemove = null;
      this.pendingRemoveBusy = false;
      document.documentElement.style.overflow = '';
    },

    async confirmRemoveOnly() {
      if (!this.pendingRemove || this.pendingRemoveBusy) return;
      const key = this.pendingRemove.key;
      this.pendingRemoveBusy = true;
      try {
        await this._changeCart(key, 0);
      } finally {
        this.pendingRemoveBusy = false;
        this.pendingRemove = null;
        document.documentElement.style.overflow = '';
      }
    },

    /* "Favoriye ekle ve sil".
       Favori ekleme ÖNCE yapılır: sepetten çıkarma her koşulda beklenen sonuç,
       ama önce silip sonra favori eklemeye çalışırsak ve favori tarafı hata
       verirse ürün hem sepetten hem favoriden düşmüş olur — geri alması zor bir
       kayıp. Favori eklenemezse silmeye yine de devam ederiz; kullanıcı bir
       "sil" eylemi başlattı, onu yarıda bırakmak daha kafa karıştırıcı olur. */
    async confirmRemoveAndSave() {
      if (!this.pendingRemove || this.pendingRemoveBusy) return;
      const item = this.pendingRemove;
      this.pendingRemoveBusy = true;
      try {
        await window.gaWishlistAdd(item);
        await this._changeCart(item.key, 0);
      } finally {
        this.pendingRemoveBusy = false;
        this.pendingRemove = null;
        document.documentElement.style.overflow = '';
      }
    },
  }));
});

withAlpine((Alpine) => {
  Alpine.data('gaAddToCart', (cfg = {}) => ({
    selectedVariant: cfg.initialVariantId || null,
    productId: cfg.productId || null,
    quantity: 1,
    adding: false,
    showDynamicCheckout: cfg.showDynamicCheckout ?? true,
    showGiftCardRecipient: cfg.showGiftCardRecipient ?? false,

    decrement() {
      if (this.quantity > 1) this.quantity--;
    },

    increment() {
      this.quantity++;
    },

    buildPayload(fd) {
      const p = {};
      fd.forEach((v, k) => {
        if (v === '' || v === null) return;
        if (p[k] === undefined) p[k] = v;
        else {
          if (!Array.isArray(p[k])) p[k] = [p[k]];
          p[k].push(v);
        }
      });
      return p;
    },

    async submitForm(evt) {
      if (this.adding) return;
      this.adding = true;

      try {
        const form = evt.target.closest('form');

        if (form && this.selectedVariant) {
          const idInput = form.querySelector('[name="id"]');
          if (idInput) idInput.value = this.selectedVariant;
        }

        const payload = this.buildPayload(new FormData(form));

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!addRes.ok) {
          const err = await addRes.json().catch(() => ({}));
          const msg = err.description || err.message || window.cartStrings?.error || window.cartStrings?.could_not_add || 'Could not add to cart';
          alert(msg);
          return;
        }

        /* The cart drawer's fetchCart() sets the `platform` attribute in the
           same write it uses to refresh discounts, so no extra request here. */
        window.dispatchEvent(new CustomEvent('toggle-cart'));
      } catch (e) {
        window.gaErr('[GA] add-to-cart error', e);
      } finally {
        this.adding = false;
      }
    },
  }));
});